import { SessionHandler } from "./SessionHandler.js";
import { ImageQuery } from "./APITypes.js";

export class NDVIAPI {
    /**
     * Gets the information for a single device
     * @param query an enclosureID, deviceID, or PCB QR code corresponding to query.
     */
    static async getMany(query: Partial<ImageQuery> = {}): Promise<Record<string, unknown>> {
        let url = "images/allAuth";
        if (query.startTime && query.endTime) {
            url = `images/${query.startTime.toString()}/${query.endTime.toString()}`;
        }
        const response = await SessionHandler.doFetch(url, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "GET",
            redirect: "follow",
        });
        return (await response.json()).allImages;
    }

    /**
     * Creates a device based on the provided parameters
     * @param enclosureID
     * @param lat
     * @param long
     * @param connectedZones {string[]} Also known as V2
     * @param  deviceType Also known as V1
     * @param options
     * @return {Promise<any>}
     */
    static async addOne(
        _enclosureID: string,
        _lat: number,
        _long: number,
        _connectedZones: string[],
        _deviceType,
        _options: Record<string, string>,
    ): Promise<Record<string, unknown>> {
        throw new Error("Not implemented");
    }

    /**
     * Delete a single device based on it's ID
     * @param devId ID of device to delete
     */
    static async deleteOne(_devId: string): Promise<boolean> {
        throw new Error("Not implemented");
    }

    /**
     * Gets the information for a single device
     * @param query an enclosureID, deviceID, or PCB QR code corresponding to query.
     */
    static async editOne(_id: string, _args): Promise<Record<string, unknown>> {
        throw new Error("Not implemented");
    }
}
